import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getCurrentUser } from 'aws-amplify/auth';

import styles from "./style.module.scss";

// reactstrap components
import {
  Container,
} from "reactstrap";

import loginBg from '@assets/login-slide-1.png';
import LoadingScreen from "@components/content/LoadingScreen";
import { fetchSuscription } from "@/api/SuscriptionsApi";
import { useDispatch } from "react-redux";
import { clearSuscriptionData, setSuscriptionData, setTenantData } from "@/store/slices/suscriptionSlides";
import { HaciendaApi } from "@/atv/HaciendaApi";
import { CurrencyApi } from "@/api/CurrencyApi";
import { DOLLAR_CURRENCY_ID } from "@utils/Constants";
import { setUsdExchange } from "@/store/slices/currencySlides";
import { useAppSelector } from "@/store/hooks";
import { TenantApi } from "@/api/TenantApi";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const compraUsd = useAppSelector(state => state.currency.compraUsd || 0)
  const ventaUsd = useAppSelector(state => state.currency.ventaUsd || 0)

  useEffect(() => {
    setIsLoading(true);
    checkIfUserIsLoggedIn();
  }, [])

  const checkIfUserIsLoggedIn = async () => {
    try {
      await getCurrentUser();
      await loadInitialData();

      onUserLoggedIn();
    } catch (err) {
      dispatch(clearSuscriptionData())
      // No current user, proceed with login
    } finally {
      setIsLoading(false);
    }
  }

  const loadInitialData = async () => {
    const profile = await fetchSuscription()
    dispatch(setSuscriptionData(profile))
    try {
      const tenantData = await TenantApi.fetchTenantBySuscriptionId(`${profile.id}`)
      dispatch(setTenantData(tenantData))
    } catch (err) {
      console.error("Unable to load TenantData", err)
    }
    try {
      const { sync_dolar } = profile;
      if (sync_dolar) {
        if (!compraUsd || !ventaUsd) {
          const tipoCambio = await HaciendaApi.getTipoCambioDolar();
          if (tipoCambio.venta) {
            const { items: currencies } = await CurrencyApi.fetchAll();
            const dollarCurrency = currencies.find(c => c.currency_id == DOLLAR_CURRENCY_ID)
            if (dollarCurrency?.id) {
              await CurrencyApi.update(dollarCurrency.id, { exchange_rate: tipoCambio.venta.valor })
            }
            dispatch(setUsdExchange({
              compra: Number(tipoCambio.compra.valor || 0),
              venta: Number(tipoCambio.venta.valor || 0),
            }))
          }
        }
      }
    } catch (err) {
      console.log(err, "No fue posible actualizar el tipo de cambio")
    }
  }

  const onUserLoggedIn = () => {
    navigate('/user/dashboard');
  }

  return (
    <>
      <div className={styles.loginContent}>
        <Container fluid className="p-0">
          <img className={styles.responsiveImg} src={loginBg} alt="Login slide" />
        </Container>
        <LoadingScreen isLoading={isLoading} />
      </div>
    </>
  );
}

export default Login;
